import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';
import config from '../../config';
import logo from '../../assets/images/logo.png';

const PublicHeader: React.FC = () => {
  const { isAuthenticated } = useAuthStore();
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  return (
    <nav className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center flex-shrink-0">
            <img src={logo} alt={`${config.appName} Logo`} className="h-8 w-auto mr-2" />
            <span className="text-lg sm:text-xl font-bold text-gray-900">{config.appName}</span>
          </Link>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/pricing" className="text-gray-700 hover:text-primary-600 transition-colors text-sm lg:text-base">
              Pricing
            </Link>
            <Link to="/how-to-use" className="text-gray-700 hover:text-primary-600 transition-colors text-sm lg:text-base">
              How to Use
            </Link>
            <Link to="/use-cases" className="text-gray-700 hover:text-primary-600 transition-colors text-sm lg:text-base">
              Use Cases
            </Link>
            <Link to="/private-ai" className="text-gray-700 hover:text-primary-600 transition-colors text-sm lg:text-base">
              Private AI/LLM
            </Link>
            {isAuthenticated ? (
              <Link
                to="/chat"
                className="bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-colors font-medium text-sm"
              >
                Go to AI
              </Link>
            ) : (
              <>
                <Link
                  to="/register"
                  className="text-gray-700 hover:text-primary-600 transition-colors font-medium text-sm"
                >
                  Sign Up
                </Link>
                <Link
                  to="/login"
                  className="bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-colors font-medium text-sm"
                >
                  Login
                </Link>
              </>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            type="button"
            className="md:hidden p-2 rounded-md text-gray-700 hover:text-primary-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-gray-200 py-4">
            <div className="flex flex-col space-y-4">
              <Link
                to="/pricing"
                className="text-gray-700 hover:text-primary-600 transition-colors px-2 py-2 text-base font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Pricing
              </Link>
              <Link
                to="/how-to-use"
                className="text-gray-700 hover:text-primary-600 transition-colors px-2 py-2 text-base font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                How to Use
              </Link>
              <Link
                to="/use-cases"
                className="text-gray-700 hover:text-primary-600 transition-colors px-2 py-2 text-base font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Use Cases
              </Link>
              <Link
                to="/private-ai"
                className="text-gray-700 hover:text-primary-600 transition-colors px-2 py-2 text-base font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Private AI/LLM
              </Link>
              {isAuthenticated ? (
                <Link
                  to="/chat"
                  className="bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-colors font-medium text-center"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Go to AI
                </Link>
              ) : (
                <>
                  <Link
                    to="/register"
                    className="text-gray-700 hover:text-primary-600 transition-colors px-2 py-2 text-base font-medium"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Sign Up
                  </Link>
                  <Link
                    to="/login"
                    className="bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-colors font-medium text-center"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Login
                  </Link>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default PublicHeader;

